{
  "common": {
    "loading": "Loading...",
    "cancel": "Cancel",
    "close": "Close",
    "update": "Update",
    "create": "Create",
    "confirm": "Confirm",
    "processing": "Processing...",
    "yes": "Yes",
    "no": "No",
    "unknown": "Unknown",
    "actionFailed": "Action failed"
  },
  "tierLabels": {
    "starter": "Starter",
    "silver": "Silver",
    "gold": "Gold",
    "platinum": "Platinum"
  },
  "statusLabels": {
    "active": "Active",
    "paused": "Paused",
    "banned": "Banned"
  },
  "kycLabels": {
    "pending": "Not submitted",
    "submitted": "Pending review",
    "verified": "Verified",
    "rejected": "Rejected"
  },
  "payoutStatusLabels": {
    "requested": "Pending review",
    "approved": "Approved",
    "paid": "Paid",
    "rejected": "Rejected"
  },
  "reasonLabels": {
    "ip_reuse": "IP reuse",
    "velocity": "Abnormal velocity",
    "ua_anomaly": "Unusual user-agent",
    "manual": "Manual report"
  },
  "commissionStatusLabels": {
    "pending": "Pending",
    "locked": "Locked",
    "paid": "Paid",
    "refunded": "Refunded"
  },
  "kycDocKinds": {
    "id_front": "ID card (front)",
    "id_back": "ID card (back)",
    "selfie": "Selfie",
    "address_proof": "Proof of address"
  },
  "hub": {
    "heading": "Affiliate Management",
    "subtitle": "Affiliate list, payout queue, abuse reports and platform-wide ShortLinks.",
    "tabsAria": "Affiliate hub tabs",
    "panelAria": "{{tab}} panel",
    "tabs": {
      "list": "Affiliate list",
      "payouts": "Payout queue",
      "abuse": "Abuse reports",
      "shortlinks": "ShortLinks"
    }
  },
  "list": {
    "heading": "Affiliate List",
    "subtitle": "Affiliate list — filter by status, tier, KYC.",
    "searchPlaceholder": "Search by handle or email...",
    "filters": {
      "allTiers": "All tiers",
      "tierOption": "Tier: {{label}}",
      "allStatuses": "All statuses",
      "allKyc": "All KYC",
      "kycOption": "KYC: {{label}}"
    },
    "columns": {
      "handle": "Handle",
      "tier": "Tier",
      "status": "Status",
      "kyc": "KYC",
      "commissionMtd": "Commission MTD",
      "clicks": "Clicks",
      "conversions": "Conversions",
      "lastActive": "Last active"
    },
    "empty": "No affiliates match the filters."
  },
  "detail": {
    "loadError": "Could not load affiliate information.",
    "tierBadge": "Tier: {{label}}",
    "kycBadge": "KYC: {{label}}",
    "tabs": {
      "profile": "Profile",
      "kyc": "KYC",
      "commissions": "Commissions",
      "clicks": "Clicks",
      "payouts": "Payout history"
    },
    "actions": {
      "suspend": "Suspend",
      "changeTier": "Change tier",
      "forcePayout": "Manual payout",
      "whitelist": "Whitelist IP"
    },
    "success": {
      "suspend": "Affiliate suspended.",
      "changeTier": "Tier changed.",
      "forcePayout": "Payout request created.",
      "whitelist": "IP list updated."
    },
    "errors": {
      "suspend": "Suspend failed.",
      "changeTier": "Change tier failed.",
      "forcePayout": "Create payout failed.",
      "whitelist": "Update IP failed."
    },
    "suspendForm": {
      "title": "Suspend affiliate",
      "reasonPlaceholder": "Reason for suspension..."
    },
    "tierForm": {
      "title": "Change tier",
      "reasonPlaceholder": "Reason for tier change..."
    },
    "forcePayoutForm": {
      "title": "Manual payout",
      "amountLabel": "Amount (USD)",
      "reasonPlaceholder": "Reason..."
    },
    "whitelistForm": {
      "title": "Whitelist IP",
      "empty": "No IPs whitelisted yet.",
      "add": "Add",
      "remove": "Remove"
    },
    "profile": {
      "email": "Email",
      "fullName": "Full name",
      "createdAt": "Created at",
      "lastActive": "Last active",
      "whitelistedIps": "Whitelisted IPs"
    },
    "kyc": {
      "empty": "Affiliate has not submitted KYC documents.",
      "viewDoc": "View document",
      "uploadedAt": "Uploaded: {{date}}"
    },
    "commissions": {
      "empty": "No commissions yet.",
      "columns": {
        "order": "Order",
        "amount": "Amount",
        "status": "Status",
        "earned": "Earned at",
        "locked": "Locked at",
        "paid": "Paid at"
      }
    },
    "clicks": {
      "empty": "No clicks yet.",
      "columns": {
        "slug": "Slug",
        "ip": "IP",
        "bot": "Bot?",
        "when": "When",
        "converted": "Converted order"
      }
    },
    "payoutsHistory": {
      "empty": "No payout history yet.",
      "columns": {
        "id": "ID",
        "amount": "Amount",
        "status": "Status",
        "requested": "Requested",
        "approved": "Approved",
        "paid": "Paid"
      }
    }
  },
  "payouts": {
    "heading": "Payout Queue",
    "subtitle": "Approve / reject / mark paid affiliate withdrawal requests.",
    "filters": {
      "allStatuses": "All statuses",
      "affiliateIdPlaceholder": "Affiliate ID...",
      "minAmount": "Minimum $"
    },
    "bulkMarkPaid": "Bulk mark paid ({{count}})",
    "columns": {
      "affiliate": "Affiliate",
      "amount": "Amount",
      "status": "Status",
      "requestedAt": "Requested at",
      "banking": "Banking",
      "actions": "Actions"
    },
    "empty": "No payouts match the filters.",
    "rowActions": {
      "approve": "Approve",
      "reject": "Reject",
      "markPaid": "Mark paid"
    },
    "errors": {
      "approve": "Approve payout failed.",
      "markPaid": "Mark paid failed.",
      "reject": "Reject payout failed."
    },
    "toast": {
      "approveSuccess": "Action successful.",
      "markPaidSuccess": "Marked as paid.",
      "rejectSuccess": "Payout rejected.",
      "bulkSuccess": "Paid {{count}} payouts.",
      "bulkPartial": "Completed {{ok}}, failed {{failed}}."
    },
    "approveDrawer": {
      "title": "Approve payout",
      "commentLabel": "Comment (optional)"
    },
    "rejectDrawer": {
      "title": "Reject payout",
      "reasonLabel": "Reason for rejection"
    },
    "markPaidDrawer": {
      "title": "Mark as paid",
      "bulkTitle": "Bulk mark paid ({{count}})",
      "bulkNote": "Applies to {{count}} selected payouts.",
      "bankRefLabel": "Bank reference",
      "paidAtLabel": "Payment time",
      "proofLabel": "Proof URL (optional)",
      "grossLabel": "Gross (USD)",
      "withholdLabel": "Withholding (USD)"
    }
  },
  "abuse": {
    "heading": "Abuse Report",
    "subtitle": "Affiliate abuse reports (click fraud, self-referral).",
    "filters": {
      "allReasons": "All reasons",
      "affiliateIdPlaceholder": "Affiliate ID..."
    },
    "columns": {
      "affiliate": "Affiliate",
      "reason": "Reason",
      "flaggedAt": "Flagged at",
      "botHuman": "Bot / Human (24h)",
      "conversion": "Conversions",
      "actions": "Actions"
    },
    "empty": "No reports match the filters.",
    "rowActions": {
      "whitelist": "Whitelist",
      "suspend": "Suspend"
    },
    "errors": {
      "suspend": "Suspend failed.",
      "whitelist": "Update whitelist failed."
    },
    "toast": {
      "suspendSuccess": "Affiliate suspended.",
      "whitelistSuccess": "Whitelist updated."
    },
    "whitelistDialog": {
      "title": "Whitelist IP for @{{handle}}",
      "descPrefix": "Dismiss the flag and mark the IP as valid. This adds the IP to",
      "descSuffix": "of the affiliate (D-GA-10)."
    }
  },
  "shortlinks": {
    "heading": "Short Links",
    "subtitle": "Manage affiliate branded short-links + analytics.",
    "filters": {
      "searchPlaceholder": "Search by slug or target URL...",
      "affiliateIdPlaceholder": "Affiliate ID...",
      "allBanned": "All",
      "banned": "Banned",
      "active": "Active"
    },
    "columns": {
      "slug": "Slug",
      "affiliate": "Affiliate",
      "targetUrl": "Target URL",
      "clicks": "Clicks",
      "conversions": "Conversions",
      "status": "Status",
      "actions": "Actions"
    },
    "empty": "No ShortLinks match the filters.",
    "bannedAt": "Banned: {{date}}",
    "statusActive": "Active",
    "rowActions": {
      "ban": "Ban"
    },
    "errors": {
      "ban": "Ban failed."
    },
    "toast": {
      "banSuccess": "ShortLink banned."
    },
    "banDialog": {
      "title": "Ban ShortLink /r/{{slug}}",
      "desc": "This soft-deletes the ShortLink. Subsequent resolves return 410 Gone. State the reason so the audit log has context.",
      "reasonLabel": "Reason"
    }
  }
}
